import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import { CardCompletionTypeEnum } from 'appConsts';

/* returns
    TRUE if LOCKED
    FALSE if NOT LOCKED
*/
const checkIfCardLocked = (cardInfoArray, cardPid) => {
  const inCompletedCardIndex = findIndex(
    cardInfoArray,
    card => ((!card.isGradable && card.completionStatus !== 'COMPLETE')
        || (card.isGradable && card.successStatus !== 'PASS'))
      && card.completionType !== CardCompletionTypeEnum.optional
  );

  const currentCardIndex = findIndex(cardInfoArray, card => card.pid === cardPid);
  const currentCard = find(cardInfoArray, card => card.pid === cardPid);

  if (currentCardIndex > inCompletedCardIndex && inCompletedCardIndex !== -1) {
    // Peer review card check
    if (
      currentCard.type === 'peerReviewCard'
      && cardInfoArray[currentCardIndex - 1]
      && cardInfoArray[currentCardIndex - 1].isAccessible
      && cardInfoArray[currentCardIndex - 1].completionStatus === 'COMPLETE'
    ) {
      return false;
    }

    // Card after Peer review card check :p
    if (
      cardInfoArray[currentCardIndex - 1]
      && cardInfoArray[currentCardIndex - 1].type === 'peerReviewCard'
      && cardInfoArray[currentCardIndex - 1].isAccessible
    ) {
      return false;
    }

    return true;
  }
  return false;
};

export default checkIfCardLocked;
